/* pf-lp.js: Aploomb PostureFit PDP behaviour. Loaded with defer from snippets/pf-head (once per pf section; runs once). */
(function(){
if (window.__pfLp) return; window.__pfLp = 1;
var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ---------- buy box: gallery, tiers, live price ---------- */
var BUY = document.querySelector('[data-pf-buy]');
var U = BUY ? +BUY.getAttribute('data-u') || 0 : 0;
var D = Math.ceil(U * 75 / 100); /* higher of Shopify's two roundings: the basket may come out a penny cheaper, never dearer */
var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || (BUY && BUY.getAttribute('data-cur')) || 'GBP';
var nf; try { nf = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency', currency:cur}); } catch(e) {}
function fmt(c){ return nf ? nf.format(c/100) : (c/100).toFixed(2); }
function qty(){ var r = document.querySelector('input[name="pfq"]:checked'); return r ? +r.value : 1; }
function sync(){
  if (!BUY) return;
  var q = qty(), t = fmt(U + (q - 1) * D);
  document.querySelectorAll('#total, #px, [data-pf-total]').forEach(function(n){ n.textContent = t; });
  var sub = document.getElementById('px-sub');
  if (sub) sub.textContent = q === 1 ? sub.dataset.one : (q + ' ' + sub.dataset.many);
  document.querySelectorAll('.lot').forEach(function(l){ l.classList.toggle('on', +l.dataset.q === q); });
}
if (BUY) {
  var gal = document.getElementById('gal'), th = document.getElementById('thumbs');
  if (gal && th) th.addEventListener('click', function(e){
    var b = e.target.closest('button'); if (!b) return;
    if (b.dataset.srcset) gal.srcset = b.dataset.srcset; else gal.removeAttribute('srcset');
    gal.src = b.dataset.src; var i = b.querySelector('img'); if (i && i.alt) gal.alt = i.alt;
    th.querySelectorAll('button').forEach(function(x){ x.removeAttribute('aria-current'); });
    b.setAttribute('aria-current', 'true');
  });
  document.querySelectorAll('input[name="pfq"]').forEach(function(r){ r.addEventListener('change', sync); });
  sync();
}

/* ---------- every buy button: add the selected tier (+ add-on if ticked) + exactly 1 of each free perk, then go straight to checkout ---------- */
/* Included-free perks: £0 UNLISTED products (ids in aploomb-uk/store-perks.json). Not in any discount, so the BxGy tiers are unaffected. */
var PERKS = [51136697958625 /* Starter Plan */, 51136697860321 /* Parcel Cover */];
var PF_PRODUCT = 10385480909025;
var busy = false;
function proot(){ return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
function api(path, body){
  return fetch(proot() + path, body ? { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify(body) } : { headers:{'Accept':'application/json'} })
    .then(function(r){ return r.json().then(function(d){ if (!r.ok || d.status) throw d; return d; }); });
}
function checkout(btn){
  if (busy) return;
  var v = +(btn.getAttribute('data-v') || 0) || (BUY ? +BUY.getAttribute('data-v') : 0);
  var root = proot();
  if (!v) { window.location.href = (BUY && BUY.getAttribute('data-url')) || btn.getAttribute('data-url') || root; return; }
  busy = true; btn.disabled = true; btn.setAttribute('aria-busy', 'true');
  var items = [{ id: v, quantity: qty() }];
  document.querySelectorAll('input[data-pf-addon]:checked').forEach(function(a){ var id = +a.getAttribute('data-pf-addon'); if (id) items.push({ id: id, quantity: 1 }); });
  function go(){ window.location.href = root + 'checkout'; }
  function fail(){ busy = false; btn.disabled = false; btn.removeAttribute('aria-busy'); window.location.href = root + 'cart'; }
  api('cart.js').then(function(c){
    var have = {}, fix = {}, fixing = false, add = [];
    c.items.forEach(function(i){ if (PERKS.indexOf(i.variant_id) > -1) have[i.variant_id] = (have[i.variant_id] || 0) + i.quantity; });
    PERKS.forEach(function(id){
      if (!have[id]) add.push({ id: id, quantity: 1 });
      else if (have[id] !== 1) { fix[id] = 1; fixing = true; }
    });
    /* perks first, trainer last: Shopify lists the newest line on top, so checkout reads trainer -> parcel cover -> plan */
    return (fixing ? api('cart/update.js', { updates: fix }) : Promise.resolve())
      .then(function(){ return api('cart/add.js', { items: add.concat(items.slice().reverse()) }); })
      /* a perk must never block the sale: if that call fails, add the trainer on its own */
      .catch(function(){ return api('cart/add.js', { items: items }); });
  }, function(){ return api('cart/add.js', { items: items }); })
    .then(go, fail);
}
document.addEventListener('click', function(e){
  var b = e.target.closest && e.target.closest('[data-pf-checkout]'); if (!b) return;
  e.preventDefault(); checkout(b);
});

/* ---------- perk guard: a cart with perks but no PostureFit loses the perks (cart page, drawer, any page that loads this file) ---------- */
(function(){
  var t = null, running = false;
  function guard(){
    if (busy || running) return; running = true;
    api('cart.js').then(function(c){
      if (busy) return;
      var hasPf = c.items.some(function(i){ return i.product_id === PF_PRODUCT; });
      var up = {}, n = 0;
      if (!hasPf) c.items.forEach(function(i){ if (PERKS.indexOf(i.variant_id) > -1) { up[i.variant_id] = 0; n++; } });
      if (!n) return;
      return api('cart/update.js', { updates: up }).then(function(){
        if (document.getElementById('main-cart-items')) { window.location.reload(); return; }
        var d = document.querySelector('cart-drawer'); if (d && d.refreshCartDrawer) d.refreshCartDrawer();
      });
    }).catch(function(){}).then(function(){ running = false; });
  }
  guard();
  var drawer = document.getElementById('CartDrawer');
  if (drawer && window.MutationObserver) new MutationObserver(function(){ clearTimeout(t); t = setTimeout(guard, 500); }).observe(drawer, { childList: true, subtree: true });
})();

/* ---------- video rail: lazy posters + sources, play in view, sound toggle, scroll cue + arrows ---------- */
document.querySelectorAll('.vgc').forEach(function(sec){
  var row = sec.querySelector('[data-vgc]'); if (!row) return;
  var vids = [].slice.call(row.querySelectorAll('video[data-src]'));
  function poster(v){
    var p = v.getAttribute('data-poster'); if (!p || v.poster) return;
    var w = Math.min(720, Math.ceil((v.clientWidth || 240) * (window.devicePixelRatio || 1) / 80) * 80);
    try { var u = new URL(p, location.href); if (/cdn\.shopify\.com|\/cdn\/shop\//.test(u.href)) u.searchParams.set('width', w); v.poster = u.href; } catch(e) { v.poster = p; }
  }
  function load(v){ poster(v); if (!v.src) { v.src = v.dataset.src; v.load(); } }
  if (!('IntersectionObserver' in window)) { vids.forEach(load); }
  else {
    var near = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting) { poster(e.target); near.unobserve(e.target); } }); }, { rootMargin: '400px' });
    var view = new IntersectionObserver(function(es){ es.forEach(function(e){ var v = e.target;
      if (e.isIntersecting && !reduce) { load(v); var p = v.play(); if (p && p.catch) p.catch(function(){}); } else { v.pause(); } }); }, { rootMargin: '0px', threshold: .35 });
    vids.forEach(function(v){ near.observe(v); view.observe(v); });
  }
  vids.forEach(function(v){
    var f = v.closest('.vgc__f'), b = f && f.querySelector('.vgc__snd');
    function toggle(){ load(v); v.muted = !v.muted;
      if (!v.muted) { vids.forEach(function(o){ if (o !== v) { o.muted = true; var ob = o.closest('.vgc__f').querySelector('.vgc__snd'); if (ob) { ob.setAttribute('aria-pressed','false'); ob.setAttribute('aria-label','Turn sound on'); } } }); var p = v.play(); if (p && p.catch) p.catch(function(){}); }
      if (b) { b.setAttribute('aria-pressed', String(!v.muted)); b.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off'); } }
    v.addEventListener('click', toggle); if (b) b.addEventListener('click', function(e){ e.stopPropagation(); toggle(); });
  });
  var prev = sec.querySelector('[data-vgc-prev]'), next = sec.querySelector('[data-vgc-next]');
  function step(){ var c = row.querySelector('.vgc__c'); if (!c) return row.clientWidth; var g = parseFloat(getComputedStyle(row).columnGap) || 0; return Math.max(c.getBoundingClientRect().width + g, Math.floor(row.clientWidth / (c.getBoundingClientRect().width + g)) * (c.getBoundingClientRect().width + g) - (c.getBoundingClientRect().width + g)); }
  function state(){
    var max = row.scrollWidth - row.clientWidth;
    var over = max > 4, end = row.scrollLeft >= max - 4, start = row.scrollLeft <= 4;
    sec.classList.toggle('vgc--over', over);
    sec.classList.toggle('vgc--end', !over || end);
    if (prev) prev.disabled = !over || start;
    if (next) next.disabled = !over || end;
  }
  if (prev) prev.addEventListener('click', function(){ row.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
  if (next) next.addEventListener('click', function(){ row.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
  var raf; row.addEventListener('scroll', function(){ cancelAnimationFrame(raf); raf = requestAnimationFrame(state); }, { passive: true });
  window.addEventListener('resize', state, { passive: true });
  state();
});

/* ---------- avatars accordion: everything closed until the customer clicks ---------- */
document.querySelectorAll('[data-pf-av]').forEach(function(root){
  if (root.dataset.avReady) return; root.dataset.avReady = '1';
  var items = [].slice.call(root.querySelectorAll('[data-av-it]'));
  var pics = [].slice.call(root.querySelectorAll('[data-av-pic]'));
  var rail = root.querySelector('.av__pics'), frame = root.querySelector('.av__frame');
  function showPic(i, scroll){
    pics.forEach(function(p, k){ p.classList.toggle('is-on', k === i); });
    if (frame) frame.classList.toggle('has-on', i > -1);
    if (scroll && i > -1 && rail && rail.scrollWidth > rail.clientWidth + 4) {
      var p = pics[i]; var pad = parseFloat(getComputedStyle(rail).paddingLeft) || 0;
      rail.scrollTo({ left: p.offsetLeft - pad, behavior: reduce ? 'auto' : 'smooth' });
    }
  }
  function open(i, opts){
    opts = opts || {};
    items.forEach(function(it, k){ var on = k === i; it.classList.toggle('is-open', on); it.querySelector('.av__btn').setAttribute('aria-expanded', on ? 'true' : 'false'); });
    showPic(i, opts.scroll !== false);
  }
  items.forEach(function(it, k){ it.querySelector('.av__btn').addEventListener('click', function(){ open(it.classList.contains('is-open') ? -1 : k); }); });
  pics.forEach(function(p, k){ p.addEventListener('click', function(){ open(items[k] && items[k].classList.contains('is-open') ? -1 : k, { scroll: false }); }); });
  document.addEventListener('shopify:block:select', function(e){
    var el = e.target && e.target.closest && e.target.closest('[data-av-it],[data-av-pic]');
    if (!el || !root.contains(el)) return;
    open(parseInt(el.getAttribute('data-av-it') || el.getAttribute('data-av-pic'), 10));
  });
});

/* ---------- review wall ---------- */
(function(){
  var sec=document.getElementById('reviews'), src=document.getElementById('pf-rv-data');
  if(!sec||!src||!sec.querySelector('[data-rv-grid]')) return;
  var AV=[], PER=(+sec.getAttribute('data-per'))||8; try{ AV=JSON.parse(src.textContent)||[]; }catch(e){}
  AV=AV.filter(function(a){return a.s>=4;});
  var grid=sec.querySelector('[data-rv-grid]'), pag=sec.querySelector('[data-rv-pag]'),
      lab=sec.querySelector('[data-sort-label]'), box=sec.querySelector('[data-sort]'), wall=sec.querySelector('[data-rv-wall]');
  var filt='all', sort='useful', page=1;
  function esc(t){return String(t).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  var STAR='<svg viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"M12 3.6l2.6 5.3 5.8.85-4.2 4.1 1 5.8-5.2-2.74-5.2 2.74 1-5.8-4.2-4.1 5.8-.85z\"/></svg>';
  function stars(n){var h='<span class="rv__st" aria-label="'+n+' out of 5">';for(var i=1;i<=5;i++)h+='<i'+(i<=n?'':' class="off"')+'>'+STAR+'</i>';return h+'</span>';}
  sec.querySelector('[data-count="all"]').textContent=AV.length;
  sec.querySelector('[data-count="photo"]').textContent=AV.filter(function(a){return !!a.p;}).length;
  function list(){
    var l=AV.filter(function(a){return filt==='photo'?!!a.p:true;});
    return l.sort(sort==='recent'?function(a,b){return b.ts-a.ts;}:function(a,b){return (b.u-a.u)||(b.ts-a.ts);});
  }
  function card(a){
    return '<article class="rv__c'+(a.p?' rv__c--ph':'')+'" data-k="'+esc(a.k||'')+'">'
      +'<h4>'+esc(a.t)+'</h4>'+(a.b?'<p>'+esc(a.b)+'</p>':'')
      +(a.p?'<figure class="rv__c-ph"><img src="'+esc(a.p)+'&width=400" alt="Photo from '+esc(a.n)+'" loading="lazy" decoding="async" width="200" height="200"></figure>':'')
      +(a.r?'<div class="rv__rep"><b>Aploomb</b><p>'+esc(a.r)+'</p></div>':'')
      +'<div class="rv__sig"><span class="rv__av">'+esc(a.i)+'</span><span class="rv__id"><b>'+esc(a.n)+'</b><em>'+esc(a.d)+'</em></span>'
      +stars(a.s)+'<span class="rv__vb"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>Verified</span></div>'
      +'<div class="rv__help"><span>Was this review helpful?</span><button type="button" data-help>Yes <b>'+(a.u|0)+'</b></button></div></article>';
  }
  function pager(n){
    if(n<=1){pag.innerHTML='';return;}
    var h='<button type="button" data-go="'+(page-1)+'"'+(page===1?' disabled':'')+' aria-label="Previous page"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg></button>';
    for(var i=1;i<=n;i++)h+='<button type="button" class="rv__pg'+(i===page?' on':'')+'" data-go="'+i+'"'+(i===page?' aria-current="page"':'')+'>'+i+'</button>';
    h+='<button type="button" data-go="'+(page+1)+'"'+(page===n?' disabled':'')+' aria-label="Next page"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></button>';
    pag.innerHTML=h;
  }
  function render(move){
    var l=list(), n=Math.max(1,Math.ceil(l.length/PER)); if(page>n)page=n;
    grid.innerHTML=l.length? l.slice((page-1)*PER,page*PER).map(card).join('')
      : '<div class="rv__empty"><b>'+(filt==='photo'&&AV.length?'No photo reviews yet':'No reviews yet')+'</b><p>Reviews open after the first UK orders. Every review will come from a verified buyer.</p></div>';
    pager(l.length?n:0);
    if(move){var y=sec.querySelector('.rv__bar').getBoundingClientRect().top+window.pageYOffset-86;window.scrollTo({top:y,behavior:'smooth'});}
  }
  function setFilter(f){
    filt=f; page=1;
    sec.querySelectorAll('[data-filter]').forEach(function(o){var a=o.dataset.filter===f;o.classList.toggle('on',a);o.setAttribute('aria-selected',a?'true':'false');});
  }
  sec.querySelectorAll('[data-filter]').forEach(function(b){b.addEventListener('click',function(){setFilter(b.dataset.filter);render(false);});});
  var sb=box.querySelector('.rv__sort-b');
  sb.addEventListener('click',function(e){e.stopPropagation();var o=box.classList.toggle('open');sb.setAttribute('aria-expanded',o?'true':'false');});
  box.querySelectorAll('[data-sort-by]').forEach(function(li){li.addEventListener('click',function(){
    sort=li.dataset.sortBy; page=1; lab.textContent=li.textContent;
    box.querySelectorAll('[data-sort-by]').forEach(function(o){o.classList.toggle('on',o===li);o.setAttribute('aria-selected',o===li?'true':'false');});
    box.classList.remove('open'); sb.setAttribute('aria-expanded','false'); render(false);});});
  document.addEventListener('click',function(){box.classList.remove('open');sb.setAttribute('aria-expanded','false');});
  pag.addEventListener('click',function(e){var b=e.target.closest('[data-go]');if(!b||b.disabled)return;page=+b.dataset.go;render(true);});
  grid.addEventListener('click',function(e){var b=e.target.closest('[data-help]');if(!b||b.classList.contains('on'))return;var n=b.querySelector('b');n.textContent=(+n.textContent)+1;b.classList.add('on');});
  // photo wall: one tile per photo review, in wall order; a tile jumps to the review that sent it
  if(wall){
    var ph=AV.filter(function(a){return !!a.p;}).sort(function(a,b){return (a.w||0)-(b.w||0);});
    if(!ph.length){ wall.remove(); }
    else {
      wall.innerHTML=ph.map(function(a){return '<figure tabindex="0" role="button" data-ph="'+esc(a.k)+'" aria-label="See the review from '+esc(a.n)+'"><img src="'+esc(a.p)+'&width=320" alt="Customer photo from '+esc(a.n)+'" loading="lazy" decoding="async" width="160" height="160"></figure>';}).join('');
      function jump(k){
        setFilter('photo'); sort='useful'; lab.textContent='Most helpful';
        var l=list(), i=0; for(;i<l.length;i++){ if(l[i].k===k) break; }
        page=Math.floor(i/PER)+1; render(false);
        var c=grid.querySelector('[data-k="'+k+'"]'); if(!c) return;
        var y=c.getBoundingClientRect().top+window.pageYOffset-96; window.scrollTo({top:y,behavior:'smooth'});
        c.classList.add('rv__c--vu'); setTimeout(function(){c.classList.remove('rv__c--vu');},2000);
      }
      wall.addEventListener('click',function(e){var f=e.target.closest('[data-ph]'); if(f) jump(f.dataset.ph);});
      wall.addEventListener('keydown',function(e){if(e.key!=='Enter'&&e.key!==' ')return;var f=e.target.closest('[data-ph]'); if(f){e.preventDefault();jump(f.dataset.ph);}});
    }
  }
  render(false);
})();
(function(){
  var sec=document.getElementById('reviews'); if(!sec) return;
  var b=sec.querySelector('[data-rv-write]'), jm=sec.querySelector('[data-rv-jm]'); if(!b||!jm) return;
  function link(){ return jm.querySelector('[data-testid="write-review-button"], .jdgm-write-rev-link'); }
  b.addEventListener('click', function(){ sec.classList.add('rv--form'); var l=link(); if(l){ l.click(); } else { jm.scrollIntoView({behavior:'smooth',block:'start'}); } });
})();
})();
